var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        no: "ContactPerson",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.BillOfLadingDesignatedFreightAgentFeedback"),
        "close-on-click-modal": false,
        width: "830px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.dialogClose
      }
    },
    [
      _c("div", [
        _c("table", { staticClass: "table" }, [
          _c("tr", [
            _c("td", { staticClass: "centered-cell w-50" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.SequenceNumber")))
            ]),
            _c("td", { staticClass: "centered-cell w-100" }, [
              _vm._v(_vm._s(_vm.$t("FinanceManage.modifyField")))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.ChangeValue")))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300" }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OriginalValue")))
            ])
          ]),
          _c("tr", [
            _c("td", { staticClass: "centered-cell" }, [_vm._v(_vm._s("1"))]),
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.Shipper")))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300 h-110" }, [
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackShipperLine1))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackShipperLine2))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackShipperLine3))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackShipperLine4))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackShipperLine5))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackShipperLine6))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackShipperLine7))])
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300 h-110" }, [
              _c("p", [_vm._v(_vm._s(_vm.data.shipperLine1))]),
              _c("p", [_vm._v(_vm._s(_vm.data.shipperLine2))]),
              _c("p", [_vm._v(_vm._s(_vm.data.shipperLine3))]),
              _c("p", [_vm._v(_vm._s(_vm.data.shipperLine4))]),
              _c("p", [_vm._v(_vm._s(_vm.data.shipperLine5))]),
              _c("p", [_vm._v(_vm._s(_vm.data.shipperLine6))]),
              _c("p", [_vm._v(_vm._s(_vm.data.shipperLine7))])
            ])
          ]),
          _c("tr", [
            _c("td", { staticClass: "centered-cell" }, [_vm._v(_vm._s("2"))]),
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.Consignee")))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300 h-110" }, [
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackConsigneeLine1))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackConsigneeLine2))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackConsigneeLine3))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackConsigneeLine4))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackConsigneeLine5))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackConsigneeLine6))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackConsigneeLine7))])
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300 h-110" }, [
              _c("p", [_vm._v(_vm._s(_vm.data.consigneeLine1))]),
              _c("p", [_vm._v(_vm._s(_vm.data.consigneeLine2))]),
              _c("p", [_vm._v(_vm._s(_vm.data.consigneeLine3))]),
              _c("p", [_vm._v(_vm._s(_vm.data.consigneeLine4))]),
              _c("p", [_vm._v(_vm._s(_vm.data.consigneeLine5))]),
              _c("p", [_vm._v(_vm._s(_vm.data.consigneeLine6))]),
              _c("p", [_vm._v(_vm._s(_vm.data.consigneeLine7))])
            ])
          ]),
          _c("tr", [
            _c("td", { staticClass: "centered-cell" }, [_vm._v(_vm._s("3"))]),
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.NotifyParty")))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300 h-110" }, [
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackNotifyLine1))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackNotifyLine2))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackNotifyLine3))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackNotifyLine4))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackNotifyLine5))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackNotifyLine6))]),
              _c("p", [_vm._v(_vm._s(_vm.data.feedbackNotifyLine7))])
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300 h-110" }, [
              _c("p", [_vm._v(_vm._s(_vm.data.notifyLine1))]),
              _c("p", [_vm._v(_vm._s(_vm.data.notifyLine2))]),
              _c("p", [_vm._v(_vm._s(_vm.data.notifyLine3))]),
              _c("p", [_vm._v(_vm._s(_vm.data.notifyLine4))]),
              _c("p", [_vm._v(_vm._s(_vm.data.notifyLine5))]),
              _c("p", [_vm._v(_vm._s(_vm.data.notifyLine6))]),
              _c("p", [_vm._v(_vm._s(_vm.data.notifyLine7))])
            ])
          ]),
          _c("tr", [
            _c("td", { staticClass: "centered-cell h-25" }, [
              _vm._v(_vm._s("4"))
            ]),
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.PortOfLoadingOnBl")))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300" }, [
              _vm._v(_vm._s(_vm.data.feedbackLoadingPort))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300" }, [
              _vm._v(_vm._s(_vm.data.loadingPort))
            ])
          ]),
          _c("tr", [
            _c("td", { staticClass: "centered-cell h-25" }, [
              _vm._v(_vm._s("5"))
            ]),
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.BillPortOfDischarge")))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300" }, [
              _vm._v(_vm._s(_vm.data.feedbackDischargingPort))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300" }, [
              _vm._v(_vm._s(_vm.data.dischargingPort))
            ])
          ]),
          _c("tr", [
            _c("td", { staticClass: "centered-cell h-25" }, [
              _vm._v(_vm._s("6"))
            ]),
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.BillLadingPlaceOfDelivery")))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300" }, [
              _vm._v(_vm._s(_vm.data.feedbackDestinationPort))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300" }, [
              _vm._v(_vm._s(_vm.data.destinationPort))
            ])
          ]),
          _c("tr", [
            _c("td", { staticClass: "centered-cell h-110" }, [
              _vm._v(_vm._s("7"))
            ]),
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.CommodityName")))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300" }, [
              _vm._v(_vm._s(_vm.data.feedbackCargoEnglishName))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300" }, [
              _vm._v(_vm._s(_vm.data.cargoEnglishName))
            ])
          ]),
          _c("tr", [
            _c("td", { staticClass: "centered-cell h-110" }, [
              _vm._v(_vm._s("8"))
            ]),
            _c("td", { staticClass: "centered-cell" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.Marks")))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300" }, [
              _vm._v(_vm._s(_vm.data.feedbackMark))
            ]),
            _c("td", { staticClass: "left-aligned-cell w-300" }, [
              _vm._v(_vm._s(_vm.data.mark))
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "tips" }, [
        _vm.data.status === 1
          ? _c("span", { staticClass: "block-span" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.AgentFeedbackRemarks1")))
            ])
          : _vm._e(),
        _vm.data.status === 2
          ? _c("span", { staticClass: "block-span" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.AgentFeedbackRemarks2")))
            ])
          : _vm._e(),
        _vm.data.status === 2
          ? _c("span", { staticClass: "block-span" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.AgentFeedbackRemarks3")))
            ])
          : _vm._e()
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _vm.data.status === 0
            ? _c(
                "el-button",
                {
                  staticClass: "button-left",
                  attrs: { no: "1", type: "danger" },
                  on: { click: _vm.rejected }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Rejected")))]
              )
            : _vm._e(),
          _vm.data.status === 0
            ? _c(
                "el-button",
                {
                  attrs: { no: "2", type: "primary" },
                  on: { click: _vm.confirm }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.AcceptChange")))]
              )
            : _vm._e(),
          _c("el-button", { attrs: { no: "3" }, on: { click: _vm.cancel } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }